import React from 'react';
import YouTube from 'react-youtube';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import DialogTitle from '@material-ui/core/DialogTitle';
import Dialog from '@material-ui/core/Dialog';
import { Typography, Button } from '@material-ui/core';
import Grid from '@material-ui/core/Grid';

const useStyles = makeStyles(theme => ({
    videoWrapper: {
        position: 'relative',
        paddingBottom: '46.25%',
        height: 0
    },
    videoIframe: {
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%'
    }
}));


function Video(props) {
    const opts = {
        height: '390',
        width: '640',
        playerVars: { 
            controls: 0,
            disablekb: 1,
            fs: 0,
            playsinline: 1,
            start: 0
        }
        
    };
    const classes = useStyles();
    return (
        <React.Fragment>
            <YouTube
                containerClassName={classes.videoWrapper}
                className={classes.videoIframe}
                videoId={props.videoId}
                opts={opts}
                onReady={props.onReady}
                onPause = {props.onPause}
                onPlay = {props.onPlay}
            />
            <Grid container justify="center">
                <Grid item xs={12}>
                    <Grid container justify="center">
                        <Grid item>
                            <Button variant="contained" size="large" color="primary" onClick={props.restartVideo}>Restart Video From Begining</Button>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
            <Dialog onClose={props.handleClose} aria-labelledby="simple-dialog-title" open={props.open}>
                <DialogTitle id="simple-dialog-title"><Typography variant="h3" component="h1"><div>{props.codeMessage}</div><div>{props.code}</div></Typography></DialogTitle>
            </Dialog>
        </React.Fragment>
    );
}

export default Video;
